import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
`;
const RegionButton = styled.button `
  ${ButtonReset}
  display: inline-flex;
  gap: 6px;

  &[data-active='true'] {
    svg {
      transform: rotate(180deg);
    }
  }

  svg {
    width: 11px;
    flex: 0 0 11px;
  }


  &:hover,
  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--textColor);
  }
`;
const RegionImage = styled.img `
`;
const RegionLabel = styled.span `
  ${fonts.montserrat.medium};
  font-size: 18px;
  line-height: 1;
  padding-right: 2px;
`;
const RegionDropDown = styled.div `
  padding: 12px 16px;
  
  flex-direction: column;
  gap: 24px;
  display: none;
  background-color: ${brand.white};
  border-radius: 8px;
  width: max-content;
  position: absolute;
  top: calc(100% + 20px);
  right: -20px;
  z-index: 1;  

  &:after {
    bottom: 100%;
    left: 80%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: ${brand.white};
    border-width: 10px;
    margin-left: -10px;
    transform: scaleX(0.6);
  }

  &[data-active='true'] {
    display: flex;
  }

  @media ${until(Device.DesktopSmall)} {
    top: auto;
    bottom: calc(100% + 20px);
    left: 50%;
    right: auto;
    transform: translateX(-50%);

    &:after {
      bottom: auto;
      top: 100%;
      left: 50%;
      border-top-color: ${brand.white};
    }
  }
`;
const RegionOption = styled.a `
  color: ${brand.black};
  display: inline-flex;
  gap: 5px;
  position: relative;
  text-decoration: none;
  align-items: center;
  justify-content: space-between;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -12px;
    height: 1px;
    background: ${brand.grey.grey80};
  }

  ${RegionLabel} {
    font-size: 14px;
  }

  &[data-is-selected='true'] {
    svg {
      opacity: 1;
    }
  }

  svg {
    opacity: 0;
    width: 14px;
  } 
`;
const RegionContent = styled.div `
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const RegionSelectorStyles = {
    Container,
    RegionButton,
    RegionImage,
    RegionLabel,
    RegionDropDown,
    RegionOption,
    RegionContent,
};
